// extracted by mini-css-extract-plugin
export var backupIcon = "_o8-1";
export var image = "_o8-0";